import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from '../../service/main/auth.service';
import { SettingsService } from '../../service/common/settings.service';
import Enums from '../../utils/enums';


@Injectable()
export class PoliceGuardService implements CanActivate {

    constructor(private authService: AuthService,
        private router: Router, 
        private settingsService: SettingsService
    ) { }

    canActivate() {
        if (this.authService.getUserToken()) {
            if (this.authService.getUserLoginRole() == this.settingsService.LOGIN_ROLE(Enums.eRole.Administrator)
                || this.authService.getUserLoginRole() == this.settingsService.LOGIN_ROLE(Enums.eRole.Police)) {
                return true;
            } else {
                return false;
            }
        } else {
            this.router.navigate(['login']);
            return false;
        }
    }
}
